import {ChangeDetectionStrategy, Component, forwardRef, Inject} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {RiktekstRedigeringKomponent} from "../../riktekst-redigering";
import {MAT_DIALOG_DATA, MatDialog, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {GruppeId, HtmlTekst} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {FormControl} from "@angular/forms";
import {nil} from "felles-ng2/typer/nullish";
import {TranslateModule} from "@ngx-translate/core";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {MatToolbar} from "@angular/material/toolbar";
import {erIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatTooltip} from "@angular/material/tooltip";

const debug = initDebugger('RiktekstRedigeringFullskjermmodalKomponent');

/** Modal som viser felt for rik tekst redigering som dekker tilnærmet hele skjermen */
@Component({
    selector: 'riktekst-redigering-fullskjermmodal',
    templateUrl: 'riktekst-redigering-fullskjermmodal.html',
    styleUrl: 'riktekst-redigering-fullskjermmodal.scss',
    host: {'[class.med-tittel]': 'visTittel'},
    imports: [
        forwardRef(() => RiktekstRedigeringKomponent),
        MatDialogContent,
        TranslateModule,
        MatToolbar,
        MatButton,
        MatIcon,
        MatTooltip
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RiktekstRedigeringFullskjermmodalKomponent {

    static vis(dialog: MatDialog, parametre: DialogParametre, oversettelser: Oversettelser) {
        return dialog.open<RiktekstRedigeringFullskjermmodalKomponent, DialogParametre, void>(RiktekstRedigeringFullskjermmodalKomponent,
          {
              data: parametre,
              disableClose: true,
              ariaLabel: oversettelser.oversett(i18n('Rediger tekst')),
              height: '90%',
              width: '90%',
              panelClass: 'riktekst-redigering-fullskjermmodal-panel'
          });
    }

    visTittel: boolean;

    constructor(@Inject(MAT_DIALOG_DATA) public riktekstRedigeringParametre: DialogParametre,
                private dialogRef: MatDialogRef<RiktekstRedigeringFullskjermmodalKomponent, void>) {
        this.visTittel = erIkkeNil(riktekstRedigeringParametre.tittel);
    }

    lukk() {
        this.dialogRef.close();
    }
}

export type DialogParametre = {
    skjemakontroll: FormControl<HtmlTekst | null>;
    /** Gruppeid som søk etter entitet begrenses til ved opprettelse av internlenke. Dersom null vil ikke opprettelse av internlenke være tilgjengelig. */
    gruppeId: GruppeId | nil;
    /** dersom produsert html skal brukes i generert PDF kan denne settes til true,
     * vil da gjøre 'sett inn sideskift' formateringsvalget tilgjengelig og begrense bredden på redigeringsfeltet til 630px (som er ca tilgjengelig horisontal plass i genererte PDFer) */
    innholdBrukesIPdf: boolean;
    /** Tekst som skal vises øverst i modalen som tittel */
    tittel?: string | null;
}
